'use client';
import React from 'react';
import { Div } from '@pezeshk-book/ui-kit';
import ServicesImage from '../../../../../../../../public/images/labs';
import routes from '@routes';
import { LaboratoryActions } from '@store/lab/lab-actions';
import { useDispatch } from 'react-redux';
import ServiceItem from '@layouts/service-item';
import { useRouter } from 'next-nprogress-bar';
import { useParams } from 'next/navigation';
import getParseRoute from '@utils/helpers/parse-route';
import getDictionary from '@dictionaries-client';
import { LocaleTypes } from '@dictionaries-types';

const Plans = ({ labs }: { labs: Array<{ id: string, slug: string, title: string, image_name: 'LabHpvImage' | 'LabGeneralImage' | 'LabCheckupImage' | 'LabCoronaImage' | 'LaboratoryUploadVersionImage' | 'LabTebKarImage', new: boolean, description?: string }>}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { lang } = useParams<{lang: LocaleTypes}>();
  const { services: { laboratory: { index: { plans } } } } = getDictionary(lang);

  const handleLabSelection = ({ id, slug }: {id: string, slug: string}) => {
    dispatch(LaboratoryActions.setShoppingCartInitialState());
    dispatch(LaboratoryActions.setCityModal({ labId: id, slug: slug, open: true }));
  };

  const handlePrescriptionSelection = () => {
    dispatch(LaboratoryActions.setShoppingCartInitialState());
    if (window.location.pathname.includes('/mobile')) {
      router.push(getParseRoute({ pathname: `/mobile${routes['route.prescription.index']}`, locale: lang }));
    } else {
      router.push(getParseRoute({ pathname: routes['route.prescription.index'], locale: lang }));
    }
  };

  return (
    <Div className={`grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 md:mt-10 mt-3`}>
      {labs && labs.length ? labs.map((item) => (
        <ServiceItem buttonTitle={plans.button} key={item.id} title={item.title} image={ServicesImage[item.image_name]} id={item.id} slug={item.slug} handleSelection={handleLabSelection} />
      )) : null}
      <ServiceItem
        buttonTitle={plans.button}
        id={''}
        slug={''}
        title={plans.upload_prescription}
        image={ServicesImage.LaboratoryUploadVersionImage}
        handleSelection={handlePrescriptionSelection}
        isNew={true}
      />
    </Div>
  );
};

export default Plans;
